import type { ThemeCanvasResult } from './useThemeCanvas';

/**
 * The frame colours a canvas owner spreads onto its Box (PRNT-4898). One helper rather than a
 * hand-written spread per site: four owners each copied `backgroundColor` and two of them dropped
 * `color`, so the Aloha welcome card kept its inherited text colour instead of the theme's. The
 * next field `containerStyle` grows is picked up here, once, for every owner.
 */
export const themeCanvasBoxProps = (canvas: ThemeCanvasResult): Readonly<{ backgroundColor?: string; color?: string }> => ({
  ...(canvas.containerStyle?.backgroundColor ? { backgroundColor: canvas.containerStyle.backgroundColor } : {}),
  ...(canvas.containerStyle?.color ? { color: canvas.containerStyle.color } : {}),
});
